import dayjs from "dayjs"
import { AllVehiclesActions } from "./all-vehicles.actions"
import { AllVehiclesState } from "./all-vehicles.types"
export const PAGE_SIZE = 15
const INTIAL_STATE = {
  selectedDate: dayjs().format("YYYY-MM-DD"),
  search: "",
  page: 0,
  isBulkUpdateModalOpen: false,
  isVehicleModalOpen: false,
  selectedVehicle: null,
  vehicleOpen: {
    open: null,
    selectedTab: null,
  },
  filter: {
    departments: [],
    vehicleTypes: [],
    status: {
      AV: false,
      NA: false,
      BR: false,
      OT: false,
      RP: false,
    },
  },
}

export const allVehicleReducer = (
  state: AllVehiclesState = INTIAL_STATE,
  action: AllVehiclesActions
) => {
  switch (action?.type) {
    case "ALL_VEHICLES_CHANGE_SEARCH":
      return {
        ...state,
        search: action?.payload,
        page: 0,
      }

    case "ALL_VEHICLES_CHANGE_PAGE":
      return {
        ...state,
        page: action?.payload,
      }

    case "TOGGLE_BULK_UPDATE_MODAL":
      return {
        ...state,
        isBulkUpdateModalOpen: !state.isBulkUpdateModalOpen,
      }

    case "TOGGLE_VEHICLE_MODAL":
      return {
        ...state,
        isVehicleModalOpen: !state.isVehicleModalOpen,
        selectedVehicle: state.isVehicleModalOpen ? null : action?.payload,
      }

    case "UPDATE_SELECTED_VEHICLE":
      //
      return {
        ...state,
        selectedVehicle: {
          ...state.selectedVehicle,
          ...action.payload,
        },
      }
    case "ALL_VEHICLES_CHANGE_LIST":
      return {
        ...state,
        filter: {
          ...state.filter,
          [action.payload?.path]: action.payload?.value,
        },
      }

    case "ALL_VEHICLES_TOGGLE_NODE":
      return {
        ...state,
        filter: {
          ...state.filter,
          status: {
            ...state.filter.status,
            [action.payload.id]: !state.filter.status[action.payload.id],
          },
        },
      }

    case "UPDATE_PAYMENTS":
      const contract = state.selectedVehicle?.currentContract
      return {
        ...state,
        selectedVehicle: {
          ...state.selectedVehicle,
          currentContract: {
            ...contract,
            totalOutstanding: contract?.totalOutstanding - action.payload,
          },
        },
      }
    case "TOGGLE_VEHICLE_OPEN":
      return {
        ...state,
        vehicleOpen: {
          open: state?.vehicleOpen?.open ? null : action.payload,
          selectedTab: "details",
        },
      }

    case "CHANGE_TAB":
      return {
        ...state,
        vehicleOpen: {
          ...state.vehicleOpen,
          selectedTab: action.payload,
        },
      }
    default:
      return state
  }
}
